import {
    getAffiliatesDefaultOptions,
    getAffiliatesOptionsPaginated,
} from '@/modules/Affiliate/services'
import { AsyncFilterSelect } from '@/components/ui/filters/async-filter-select'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface AffiliateSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    showLabel?: boolean
    disabled?: boolean
    label?: string
}

/**
 * Single-select async picker to link an Affiliate to a customer.
 * The field value is the affiliate_id (scalar). The backend resolves
 * affiliate_id -> referrer_id and writes customers.referrer_id.
 */
const AffiliateSelect = <T extends FieldValues>({
    control,
    name,
    label,
    showLabel = true,
    disabled = false,
}: AffiliateSelectProps<T>) => {
    const { t } = useTranslation('customer')

    const asyncOptions = (query: string, page: number = 1) =>
        getAffiliatesOptionsPaginated(query, page)

    return (
        <AsyncFilterSelect<T>
            label={showLabel ? label || t('affiliate_of_customer') : undefined}
            placeholder={label || t('affiliate_of_customer')}
            control={control}
            name={name}
            asyncOptions={asyncOptions}
            getDefaultOptions={getAffiliatesDefaultOptions}
            disabled={disabled}
            showClearButton
        />
    )
}

export default AffiliateSelect
